import styled from "styled-components";

export const AlertBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff3e0;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #5d3e00;

  svg {
    color: #f59100;
    font-size: 18px;
    flex-shrink: 0;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 32px;
  background: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 20px 24px;
  border-radius: 8px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  small {
    font-size: 13px;
    color: #555;
    font-weight: 400;
  }

  strong {
    font-size: 20px;
    color: #111;
    font-weight: 700;
  }
`;
